import { Outlet } from 'react-router-dom'

const Catalog = () => <Outlet />

export default Catalog
